import { CREATE_ACCOUNT_REQUEST, CREATE_ACCOUNT_SUCCESS } from './createAccount';
import { DISMISS_MODAL, LOGIN_SUCCESS } from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const BIDDER_EXISTS_SUCCESS = 'la/ui/bidderExists/SUCCESS';

export type State = {
    email: string;
};

export const DEFAULT_STATE: State = {
    email: '',
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case BIDDER_EXISTS_SUCCESS:
            return {
                ...state,
                email: action.payload.email,
            };
        case CREATE_ACCOUNT_REQUEST:
        case CREATE_ACCOUNT_SUCCESS:
        case DISMISS_MODAL:
        case LOGIN_SUCCESS:
            return {
                ...state,
                email: '',
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidderExists;

const getUiBidderExists = createSelector(stateSelector, (state) => state);

export const getBidderExists = createSelector(getUiBidderExists, (state) => Boolean(state.email));

export const getBidderExistsEmail = createSelector(getUiBidderExists, (state) => state.email);

/* ACTION CREATORS */
export const bidderExistsSuccess = (email: string) => ({
    payload: { email },
    type: BIDDER_EXISTS_SUCCESS,
});
